<template lang="pug">
v-select(
  v-bind='$attrs'
  v-bind.props='$props'
  :items='list'
  @input='$emit("input", $event)'
  @change='$emit("change", $event)'
  item-value='id'
  item-text='complex_name'
)
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import picker from '@/mixins/picker'

export default {
  mixins: [picker],

  props: {
    label: {
      default: 'Выберите комплекс'
    }
  },

  created() {
    this.fetch()
  },

  methods: mapActions('dictionary/checklistComplexes', ['fetch']),
  computed: mapGetters('dictionary/checklistComplexes', ['list'])
}
</script>
